import React, { useEffect } from "react";

import Aux from "../../hoc/Aux";
import Backdrop from "../backdrop";
import Pexels from "../../assets/imgs/pexels.jpg";

export default function Modal(props) {
  const { modalClosed, show, backgroundImg } = props;

  const backgroundStyle =
    backgroundImg != null
      ? {
          backgroundSize: "cover",
          backgroundImage: `url(${backgroundImg})`,
          backgroundPosition: "",
        }
      : {
          backgroundSize: "cover",
          backgroundImage: `url(${Pexels})`,
          backgroundPosition: "center",
        };

  useEffect(() => {
    const closeOnEscapePressed = (e) => {
      if (e.key === "Escape") {
        modalClosed();
      }
    };
    window.addEventListener("keydown", closeOnEscapePressed);
    return () => window.removeEventListener("keydown", closeOnEscapePressed);
  }, []);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden"; // Disable scroll
    } else {
      document.body.style.overflow = "auto"; // Enable scroll
    }

    // Clean up function to reset overflow when the component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  return (
    <Aux>
      <Backdrop show={props.show} toggleBackdrop={modalClosed} />

      <div
        style={backgroundStyle}
        className={props.show ? "modal show" : "modal hide"}
      >
        {props.children}
      </div>
    </Aux>
  );
}
